import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Image } from 'primereact/image';

import functions from 'lib/functions';

const EDUCATIONS2 = require('jsons/educations2.json');
const COURSE_DURATIONS = require('jsons/course_durations.json');
const EMPLOYER_TYPES = require('jsons/employer_types.json');
const RESPONSIBILITIES = require('jsons/responsibilities.json');

const WorkExperienceProfileBox = (props) => {
  const profile = props.profile;
  return (
    <Card className="work-experience-profile-box mt-2">
      <div className="grid user-detail-user">
        <div className="col-7">
          <div className="text-sm text-400">課程性質</div>
          <div className="text-base">{functions.getObjectValueFromArrayById(EDUCATIONS2.zh, profile.education_id)}&nbsp;</div>
        </div>
        <div className="col-5">
          <div className="text-sm text-400">課程長度</div>
          <div className="text-base">{functions.getObjectValueFromArrayById(COURSE_DURATIONS.zh, profile.course_duration_id)}&nbsp;</div>
        </div>
        <div className="col-7">
          <div className="text-sm text-400">完成課程</div>
          <div className="text-base">{profile.completed?<Tag value="已完成" severity="success" className="text-xs mr-1 mt-1"></Tag>:<Tag value="未完成" severity="warning" className="text-xs mr-1 mt-1"></Tag>}</div>
        </div>
        <div className="col-5">
          <div className="text-sm text-400">完成/最後上課年份</div>
          <div className="text-base">{profile.completion_year}</div>
        </div>
      </div>
    </Card>
  );
};

export default WorkExperienceProfileBox;